import { Moment } from 'moment';

export const isBusinessDay = (date: Moment) => {
  const sunday = 0;
  const saturday = 6;
  return date.day() !== sunday && date.day() !== saturday;
};

export const addBusinessDays = (originalDate: Moment, numDaysToAdd: number) => {
  let daysRemaining = numDaysToAdd;

  const newDate = originalDate.clone();

  while (daysRemaining > 0) {
    newDate.add(1, 'days');
    if (isBusinessDay(newDate)) {
      daysRemaining -= 1;
    }
  }

  return newDate;
};
